<template>
  <BModal :model-value="modal" scrollable centered title="Checkout" @update:modelValue="updateModal"> 
    <template #header>
      <div class="d-flex align-items-center justify-content-between modal-title w-100">
        <h5 class="">Checkout</h5>
        <div class="d-flex align-items-center">
          <span class="mr-2">17/02/2025 16:00:00</span>
          <div class="bg-success rounded-circle mr-2" style="width: 10px; height: 10px;"></div>
          <span>online: Ruth</span>
        </div>
      </div>
      <BButton
        variant="link"
        class="close"
        @click="updateModal(false)"
      >
        <i class="ion ion-android-close"></i>
      </BButton>
    </template>
    <BForm>
      <div class="form-group position-relative">
            <BFormInput v-model="searchQuery"
              @input="filterGuestItems"
              placeholder="Search guest name"
              autocomplete="off">
              
            </BFormInput>
            <BListGroup v-if="filteredGuestItems.length" class="position-absolute w-100 border rounded-lg" style="z-index: 10">
              <BListGroupItem v-for="guest,index of filteredGuestItems" :key="index" @click="selectGuest(guest)" class="p-2 border-0">{{ guest}}</BListGroupItem>
            </BListGroup>
            <span v-if="searchQuery && filteredGuestItems.length === 0" class="text-muted mt-2">
              Guest not found
            </span>
          </div>
      <div class="form-group">  
        <BFormSelect v-model="selectedType" :options="type_rooms">
          <template #first>
            <BFormSelectOption :value="null" disabled>Select type room</BFormSelectOption>
          </template>
        </BFormSelect>
      </div>
      <div class="form-group">  
        <BFormSelect v-model="selectedNoRoom" :options="no_rooms">
          <template #first>
            <BFormSelectOption :value="null" disabled>Select no Room</BFormSelectOption>
          </template>
        </BFormSelect>
      </div>
      <BRow>
        <BCol>
          <div class="form-group">
            <BFormInput type="text" placeholder="Sisa Tagihan" disabled>
            </BFormInput>
          </div>
        </BCol>
        <BCol>
          <div class="form-group">
            <BFormInput type="text" placeholder="Grand Total" disabled>
            </BFormInput>
          </div>
        </BCol>
      </BRow>
      <!-- <div class="d-flex justify-content-end">
          <label for="">Grand Total : Rp. 1.000.000</label>
      </div> -->
    </BForm>
    <template #footer>
          <div class="d-flex justify-content-end">
              <BButton variant="primary" @click="submitReservation" class="mr-2">Save</BButton>
              <BButton variant="danger" @click="updateModal(false)">Cancel</BButton>
          </div>
      </template>
  </BModal>
</template>

<script>
import { ref, computed } from "vue";
import { BRow, BCol, BModal, BFormInput, BButton, BListGroup, BListGroupItem } from "bootstrap-vue-next";

export default {
    props: {
        modal: Boolean,
    },
    name: 'CheckoutForm',
    components: {
        BRow, 
        BCol,
        BModal,
        BFormInput,
        BListGroup,
        BListGroupItem,
        BButton
    },
    
    emits: ["update:modal"],

    setup(props, {emit}){
        console.log(props)
        const searchQuery = ref("")
        
        const guests = ref([
          'Mr Bones', 'Ms Catherine', 'Mr Brandon', 'Mr Robert', 'Ms Emma'
        ])
        const type_rooms = ref([
          {text: 'Deluxe'}, 
          {text: 'Super Deluxe'}, 
          {text: 'Honeymoon'}, 
          {text: 'Family'}, 
          {text: 'Studio'}
        ])
        const no_rooms = ref([
          'A1', 'A2', 'A3', 'A4', 'A5'
        ])

        const updateModal = (value) => {
          emit("update:modal", value); // Sync modal state with parent
        };
        const selectGuest = (guest) => {
          searchQuery.value = guest
          filteredGuestItems.value = []
        }
        const filteredGuestItems = computed(() => {
          if (!searchQuery.value) return [];
          return guests.value.filter(item =>
            item.toLowerCase().includes(searchQuery.value.toLowerCase())
          );
        });
        return{
            updateModal,
            selectGuest,
            filteredGuestItems,
            searchQuery,
            guests,
            type_rooms,
            no_rooms
        }
    }

}
</script>

<style>

</style>